import * as React from 'react'
import { parseHyperlinkText } from '$func/hyper-link'

export function hyperLinkViewer(key: string, [result]: [string]) {
  const text = parseHyperlinkText(result)
  return (
    <span dir="ltr" key={key}>
      {text}
    </span>
  )
}
